import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { baseGridClassName, hideLastItemInGridClassName } from '@/app/lcv/components/sections/compare/styles';
import { cn } from '@/app/utils/cn';
interface RowWrapperProps {
  children: ReactNode;
  className?: string;
}
export const RowWrapper = t0 => {
  const $ = _c(5);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn(baseGridClassName, hideLastItemInGridClassName, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <div role="row" className={t1}>{children}</div>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};